import { AfterViewInit, Component, ContentChild, EventEmitter, Input, OnInit, Output, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { SelectionModel } from '@angular/cdk/collections';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { MainService } from '../../../md/service/main.service'
import { DomSanitizer } from '@angular/platform-browser';
import { ElementSchemaRegistry } from '@angular/compiler';
@Component({
  selector: 'app-common-mat-table',
  templateUrl: './common-mat-table.component.html',
  styleUrls: ['./common-mat-table.component.css']
})
export class CommonMatTableComponent {


  constructor(public mainService: MainService, public sanitizer: DomSanitizer) { }

  @Input({ required: true }) tableColumnsName: any = [];
  @Input({ required: true }) tableData: any[] = [];
  @Input({ required: true }) total_data_length: number = 0;
  @Input({ required: true }) currentPage: number = 1;
  @Input({ required: true }) pageSize: number = 10;
  @Input({ required: true }) buttonObj: any;
  @Input({ required: true }) is_response_received: boolean = false;
  @Input() showTooltip: boolean = false;
  @Input() anganwadireport: boolean = false;
  @Input() btndisabled: boolean = false;



  @ContentChild('actionTemplate', { static: false }) actionTemplate?: TemplateRef<any>;
  @ContentChild('statusButtonTemplate', { static: false }) statusButtonTemplate?: TemplateRef<any>;
  @Output() sendDataToParent: any = new EventEmitter();
  @Output() openCreate?: any = new EventEmitter();
  @Output() exportExcel?: any = new EventEmitter();
  @Output() exportall?: any = new EventEmitter();

  @ViewChild(MatPaginator, { static: false }) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(MatTable) table!: MatTable<any>;


  selectedSort: any = null;
  displayedColumns: Array<any> = [];
  dataSource: MatTableDataSource<any> = new MatTableDataSource();
  selection = new SelectionModel<any>(true, []);

  currePage: number = 0;
  pageS: number = 0;

  ngOnInit(): void {
    // Ensure a checkbox column exists as first column so select-all can render
    if (!this.anganwadireport) {
      if (!this.tableColumnsName.find((c: any) => c.key === 'checkbox')) {
        this.tableColumnsName.unshift({ key: 'checkbox', value: '' });
      }
    }
    this.displayedColumns = this.tableColumnsName.map((item: any) => item.key);
    this.dataSource = new MatTableDataSource(this.tableData);
    this.dataSource.sort = this.sort;
    this.currePage = this.currentPage
    this.pageS = this.pageS

  }

  ngOnChanges(changes: SimpleChanges) {
    // Array.isArray(this.tableData) && this.tableData.length > 0
    if (changes['tableData'] && this.tableData) {
      this.dataSource = new MatTableDataSource(this.tableData);
      this.dataSource.sort = this.sort;
      // clear selection when data changes
      this.selection.clear();
    }
    this.currePage = this.currentPage
    this.pageS = this.pageS



  }

  sendDataToGrandParent(event: any) {
    // this.searchText=""
    this.sendDataToParent.emit(event);
  }

  openCreat() {
    if (this.openCreate) {
      this.openCreate.emit();
    }
  }
  export() {
    // emit selected rows to parent (empty array if none)
    if (this.exportExcel) {
      this.exportExcel.emit(this.selection.selected || []);
    }
  }

  exportAll() {
    // emit selected rows to parent (empty array if none)
    if (this.exportall) {
      this.exportall.emit(this.selection.selected || []);
    }
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource?.filteredData?.length || 0;
    return numRows > 0 && numSelected === numRows;
  }

  masterToggle() {
    if (this.isAllSelected()) {
      this.selection.clear();
    } else {
      this.selection.select(...(this.dataSource.filteredData || []));
    }
  }

  toggleRow(row: any) {
    this.selection.toggle(row);
  }

  get searchColClass() {
    const create = this.buttonObj?.create_btn?.isCreateButton;
    const exportBtn = this.buttonObj?.export_btn?.isExportButton;
    const exportall = this.buttonObj?.exportall?.isallbtn;
    if (create && exportBtn && exportall) return 'col-6';
    if (create && exportBtn) return 'col-8';
    if (create || exportBtn) return 'col-10';
    if (create || exportall) return 'col-10';
    return 'col-12';
  }

  searchText: string = ""

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  // applySort(key:any) {
  //   let active;
  //   let direction: any;
  //   if (!this.selectedSort) {
  //     active = 'SNo';
  //     direction = 'asc'
  //   }
  //   else {
  //     direction = this.selectedSort?.toLowerCase() === 'desc' ? 'desc' : 'asc';
  //     active = key;
  //   }
  //   if (this.sort) {
  //     this.sort.active = active;
  //     this.sort.direction = direction;
  //     this.sort.sortChange.emit({ active, direction });
  //   }
  // }

  applySort(key: any) {
    if (!this.sort) return;
    let direction: 'asc' | 'desc' = 'asc';
    if (this.sort.active === key) {

      direction = this.sort.direction === 'asc' ? 'desc' : 'asc';
    }

    this.sort.active = key;
    this.sort.direction = direction;
    this.sort.sortChange.emit({ active: key, direction });
  }


  tooltipElement: HTMLElement | null = null;
  tooltipdata: any = {}
  levels: any[] = []

  showFixedTooltip(event: MouseEvent, element: any) {
    this.tooltipdata = element;

    for (let i = 1; i <= 7; i++) {
      const cd = this.tooltipdata[`lvl${i}_cd`];
      const value = this.tooltipdata[`lvl${i}_value`];
      const nodeType = this.tooltipdata[`lvl${i}_node_type`];
      const userCd = this.tooltipdata[`lvl${i}_user_cd`];

      if (cd != null && value && value.toString().trim() !== '') {
        this.levels.push({
          level: i,
          nodetype: nodeType || '-',
          code: cd,
          usercode: userCd || '-',
          value: value
        });
      }
    }
    const tooltip = (event.target as HTMLElement).querySelector('.custom-tooltip-box') as HTMLElement;
    if (!tooltip) return;

    this.tooltipElement = tooltip;
    tooltip.style.display = 'block';

    tooltip.style.top = event.clientY + 'px';
    tooltip.style.left = (event.clientX + 10) + 'px';
  }

  hideFixedTooltip() {
    this.tooltipdata = []
    this.levels = []
    if (this.tooltipElement) {
      this.tooltipElement.style.display = 'none';
    }
  }



}

